import { CostCentreTotalsContext } from 'core/centrocosto/contexts/CostCentreTotalsContext';
import { useContext } from 'react';
import { LinkButton } from 'shared/components';
import { Table } from 'shared/table';
import { formatCurrency } from 'shared/utils';

export const CostCentreTotals = () => {
  const { period, costCentreTotals, handleCostCenterRedirection } = useContext(
    CostCentreTotalsContext,
  );
  const isCurrentPeriod = !period.isValid() || period.isCurrentPeriod();
  const { totales } = costCentreTotals;
  const clickCostCentreHandler = () => {
    handleCostCenterRedirection();
  };
  return (
    <Table
      thead={
        <>
          <tr>
            <td rowSpan={2}>Centro de Costos</td>
            <td rowSpan={2}>Denominación Cuenta</td>
            <td rowSpan={2}>Saldo Inicial</td>
            <td colSpan={2}>Transferencias</td>
            <td rowSpan={2}>Acredit.</td>
            <td rowSpan={2}>Otros</td>
            <td rowSpan={2}>Extracciones</td>
            <td rowSpan={2}>Consumos</td>
            <td rowSpan={2}>Saldo</td>
            {isCurrentPeriod && (
              <>
                <td rowSpan={2}>Disponible</td>
              </>
            )}
          </tr>
          <tr>
            <td>Crédito</td>
            <td>Débito</td>
          </tr>
        </>
      }
      tbody={
        <tr key={'total-centro-costo'} data-testid={'total-centro-costo'}>
          <td>
            <LinkButton onClick={() => clickCostCentreHandler()}>
              {totales.centroCosto.denominacion} ({totales.centroCosto.codigo})
            </LinkButton>
          </td>
          <td>{costCentreTotals.denominacionCuenta}</td>
          <td>{formatCurrency(totales.saldoInicial)}</td>
          <td>{formatCurrency(totales.transferenciaCredito)}</td>
          <td>{formatCurrency(totales.transferenciaDebito)}</td>
          <td>{formatCurrency(totales.acreditaciones)}</td>
          <td>{formatCurrency(totales.otros)}</td>
          <td>{formatCurrency(totales.adelantos)}</td>
          <td>{formatCurrency(totales.consumos)}</td>
          <td>{formatCurrency(totales.saldoActual)}</td>
          {isCurrentPeriod && (
            <>
              <td>{formatCurrency(totales.saldoDisponible)}</td>
            </>
          )}
        </tr>
      }
      tfoot={
        <tr className="totals" key={'totals'} data-testid={'account-total'}>
          <td colSpan={2}>Total</td>
          <td>{formatCurrency(totales.saldoInicial)}</td>
          <td>{formatCurrency(totales.transferenciaCredito)}</td>
          <td>{formatCurrency(totales.transferenciaDebito)}</td>
          <td>{formatCurrency(totales.acreditaciones)}</td>
          <td>{formatCurrency(totales.otros)}</td>
          <td>{formatCurrency(totales.adelantos)}</td>
          <td>{formatCurrency(totales.consumos)}</td>
          <td>{formatCurrency(totales.saldoActual)}</td>
          {isCurrentPeriod && <td colSpan={1}></td>}
        </tr>
      }
    />
  );
};
